import mongoose from 'mongoose';

const { Schema } = mongoose;

const ProtektorResourceSchema = new Schema({
  resource: String,
  models: [String],
});

ProtektorResourceSchema.index(
  { resource: 1 },
  { unique: true, background: true, dropDups: true },
);

ProtektorResourceSchema.statics.findDataModels = (resource) => {
  const ProtektorResource = mongoose.model(
    'protektorresource',
    ProtektorResourceSchema,
    'ProtektorResource',
  );
  return ProtektorResource.findOne({ resource }).lean();
};

ProtektorResourceSchema.statics.insertDataModels = (resource, models) => {
  const ProtektorResource = mongoose.model(
    'protektorresource',
    ProtektorResourceSchema,
    'ProtektorResource',
  );
  return ProtektorResource.findOneAndUpdate(
    { resource },
    {
      resource,
      models,
    },
    {
      upsert: true,
      new: true,
    },
  ).lean();
};

ProtektorResourceSchema.statics.findAllResources = () => {
  const ProtektorResource = mongoose.model(
    'protektorresource',
    ProtektorResourceSchema,
    'ProtektorResource',
  );
  return ProtektorResource.find({}).lean();
};

export default () => mongoose.model(
  'protektorresource',
  ProtektorResourceSchema,
  'ProtektorResource',
);
